import { createContext } from 'react';

import type { IUseDrogasAntiEpileticas } from './IUseDrogasAntiEpileticas';

export const DrogasAntiEpileticasContext =
  createContext<IUseDrogasAntiEpileticas>({} as IUseDrogasAntiEpileticas);
